import { Reducer } from 'redux';
import { IFollowUpDocumentsState } from './types';
import { StudentActionTypes } from '../types';
import { UIActionTypes } from '../../ui/types';
import { IAnyObj, IDocument } from '../../../types';
import { DataActionTypes } from '../../data/types';
import { transformObject } from '../documents/helpers';
import { getDocDetails } from '../../../utilities/documents';

const initialState: IFollowUpDocumentsState = {
  afterArrival: {
    documentsRequired: 0,
    documentsComplete: 0,
    started: false,
    complete: false
  },
  beforeTravel: {
    studentRefusalLetter: {},
    customRequest: {},
    immigrationStatusPdfCopy: {},
    immigrationStatusShareCode: {},
    visaApplicationPdfCopy: {},
    visaVignette: {},
    travelTicket: {}
  },
  agentDocumentsRequired: 0,
  agentDocumentsComplete: 0,
  isSectionStarted: false,
  isSectionComplete: false
};

const deepMerge = (target, source) => {
  const output = { ...target };

  Object.keys(source).forEach(key => {
    if (typeof source[key] === 'object' && source[key] !== null && !Array.isArray(source[key])) {
      // If both target and source have the key as an object, recurse to merge them
      output[key] = deepMerge(target[key] || {}, source[key]);
    } else {
      // Otherwise, just assign the source value
      output[key] = source[key];
    }
  });

  return output;
};

const mainReducer: Reducer<IFollowUpDocumentsState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_FOLLOW_UP_DOCS_SUCCESS: {
      const followUpDocuments = transformObject(action.payload.followUpDocuments);

      return {
        ...state,
        ...deepMerge(state, followUpDocuments)
      };
    }
    case UIActionTypes.OPEN_FOLLOW_UP_UPLOAD_MODAL: {
      const { sponsorType, fileNames, metadata, sponsorKey, docType, docKey } = action.payload;
      if (!metadata) {
        return state;
      }
      const newState: any = { ...state };
      const newRecord = getDocDetails({ docs: newState, sponsorType, sponsorKey, docType, docKey }) as IAnyObj;

      // extend the object with new metadata, no need to craete new object ref
      Object.entries(metadata).forEach(([key, value]) => {
        if (key === 'isDocumentFixed') {
          // don't update state as fixed until file(s) have been uploaded
          newRecord.isDocumentFixedPending = value;
          newRecord.docCount = fileNames.length;
          if (newRecord.isDocumentFixed) {
            delete newRecord.isDocumentFixed;
          }
        } else if (value !== undefined && key !== 'shouldShowRequirements') {
          newRecord[key] = value;
        }
      });

      return {
        ...newState
      };
    }
    case DataActionTypes.UPLOAD_FILE_SUCCESS: {
      const { sponsorType, sponsorKey, docType, docKey, fileNames, isFollowUpModal } = action.payload;

      if (!isFollowUpModal) {
        return state;
      }

      const newState: any = { ...state };
      const newRecord = getDocDetails({ docs: newState, sponsorType, sponsorKey, docType, docKey }) as IAnyObj;

      // strip out file upload failures
      let parsedFileNames: string[] = fileNames;
      parsedFileNames = fileNames?.filter((fName: string) => !fName.includes('upload--error--')) ?? [];
      newRecord.fileNames = parsedFileNames;

      newRecord.status = 'UPLOADED_OK';
      return {
        ...newState
      };
    }
    default:
      return state;
  }
};

export { mainReducer as followUpDocumentsReducer };
